import React from 'react';
import styled from 'styled-components';

import { brandLighter, error, white } from 'variables/colors';
import { fontWeightBold } from 'variables/font';
import { transition } from 'variables/general';

const getBgColor = (value) => {
  switch (value) {
    case 'Draft':
      return '#fdcc86';
    case 'Confirmed':
      return brandLighter;
    case 'Completed':
      return '#81e196';
    case 'Cancelled':
      return '#ffb3ba';
    case 'Late Cancelled':
      return error;
    default:
      break;
  }
};

const Label = styled.div`
  width: 100%;
  color: ${white};
  font-weight: ${fontWeightBold};
  text-align: center;
  background-color: ${({ value }) => getBgColor(value)};
  cursor: pointer;
  transition: ${transition};

  &:hover {
    opacity: 0.7;
  }
`;

const StatusCell = ({ value }) => <Label value={value}>{value}</Label>;

export default StatusCell;
